export default "__VITE_ASSET__CCnsnywU__"